// Keep this list of objects in sync with the types supported in
//  /src/benchling/config_migration/object_types/object_types.py
import {customSchemaFieldsetName} from 'schemas/schema-interface/util/schemaFieldsetName';

/** The top-level object types supported by Config Migration. */
export enum PrimaryObjectType {
  EntitySchema = 'EntitySchema',
  Dropdown = 'Dropdown',
  RunSchema = 'RunSchema',
  ResultSchema = 'ResultSchema',
  BatchSchema = 'BatchSchema',
  BoxSchema = 'BoxSchema',
  ContainerSchema = 'ContainerSchema',
  LocationSchema = 'LocationSchema',
  PlateSchema = 'PlateSchema',
  TemplateCollection = 'TemplateCollection',
  Template = 'Template',
  TestDefinition = 'TestDefinition',
  LibraryParameterDefinition = 'LibraryParameterDefinition',
  Subtemplate = 'Subtemplate',
  StudySchema = 'StudySchema',
  ProcessTaskSchema = 'ProcessTaskSchema',
  ProcessOutputSchema = 'ProcessOutputSchema',
  ProcessFlowchartConfigVersion = 'ProcessFlowchartConfigVersion',
  Fieldset = 'Fieldset',
  Procedure = 'Procedure',
  AnalysisTemplate = 'AnalysisTemplate',
  RequestV2Definition = 'RequestV2Definition',
  Unit = 'Unit',
  UnitType = 'UnitType',
  Salt = 'Salt',
  Solvate = 'Solvate',
  ProteinFormat = 'ProteinFormat',
}

export enum SecondaryObjectType {
  SchemaField = 'SchemaField',
  DropdownOption = 'DropdownOption',
  ProcessFlowchartConfig = 'ProcessFlowchartConfig',
  ValidationRule = 'ValidationRule',
  ProcedureMethodDefinitionVersion = 'ProcedureMethodDefinitionVersion',
  // Keep in sync with the ProcedureParameterType DG enum
  DATA_PARAMETER = 'DATA_PARAMETER',
  MATERIAL_INPUT = 'MATERIAL_INPUT',
  MATERIAL_OUTPUT = 'MATERIAL_OUTPUT',
  EQUIPMENT = 'EQUIPMENT',
}

/**
 * Child object types that can have an additional level of child objects
 */
export const NESTED_CHILD_OBJECT_TYPES = new Set([SecondaryObjectType.ProcedureMethodDefinitionVersion]);

/**
 * The human-readable display text for each Config Migration primary object type.
 * These strings should be in sentence-case.
 */
export const PRIMARY_OBJECT_TYPE_TO_DISPLAY_TEXT: {
  [objectType in PrimaryObjectType]: string;
} = {
  EntitySchema: 'Entity schema',
  Dropdown: 'Dropdown',
  RunSchema: 'Run schema',
  ResultSchema: 'Result schema',
  BatchSchema: 'Batch schema',
  BoxSchema: 'Box schema',
  ContainerSchema: 'Container schema',
  LocationSchema: 'Location schema',
  PlateSchema: 'Plate schema',
  TemplateCollection: 'Template collection',
  Template: 'Entry template',
  Subtemplate: 'Sub-Template',
  StudySchema: 'Study schema',
  ProcessTaskSchema: 'Workflow task schema',
  ProcessOutputSchema: 'Workflow output schema',
  ProcessFlowchartConfigVersion: 'Workflow flowchart config',
  Fieldset: customSchemaFieldsetName(),
  // This text should not show up since the text depends on the procedure sub type
  Procedure: 'Procedure',
  TestDefinition: 'Test definition',
  LibraryParameterDefinition: 'Library parameter definition',
  AnalysisTemplate: 'Analysis template',
  RequestV2Definition: 'Request template',
  Unit: 'Unit',
  UnitType: 'Unit type',
  Salt: 'Salt',
  Solvate: 'Solvate',
  ProteinFormat: 'Protein format',
};

export enum MigrationSubType {
  // Keep procedure sub types in sync with ProcedureExternalType in benchling/procedures/persistence/procedure_type.py
  RECIPE = 'RECIPE',
  ASSAY = 'ASSAY',
}

export const SUB_TYPE_TO_DISPLAY_TEXT: {
  [subType in MigrationSubType]: string;
} = {
  RECIPE: 'Recipe',
  ASSAY: 'Assay',
};
